import { get_token, getCookie, get_user_id } from '@/router/index.js';
import { get_domain_style } from '@/main';

export default {
  name: 'OneTimePassword',
  data: () => ({
    otp: '',
    loading: false,
    resending: false,
    error: '',
    csrfToken: '',
    current_year: new Date().getFullYear()
  }),
  computed: {
    styleConfig() {
      return get_domain_style();
    },
    powered_by_name() {
      return this.styleConfig.powered_by_name;
    }
  },
  methods: {
    async submit_otp() {
      const token = get_token();
      if (!this.otp || this.otp.length < 6) {
        this.$notyf.error = "Please enter a valid 6-digit OTP.";
        return;
      }
      this.loading = true;

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/post_otp/';
      const cookie_url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_csrf_token/';

      try {
        await fetch(cookie_url, {
          method: 'GET',
          credentials: 'include'
        });
        this.csrfToken = getCookie('csrftoken');

        const res = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrfToken,
          },
          body: JSON.stringify({ pin: this.otp }),
        });

        const data = await res.json();
        const user_id = get_user_id();

        if (data.status === 'success') {
          this.$notyf.success("OTP verified successfully");
          localStorage.setItem('otp_verified', '1');
          localStorage.setItem('otp_required', '0');

          const next = localStorage.getItem('sso_next');
          localStorage.removeItem('sso_next');

          if (next) {
            // HARD redirect to backend launch API
            const api_url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/launch_${next}/`;

            try {
              const res = await fetch(api_url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Token ${token}`,
                  'X-Page-URL': window.location.href,
                },
                body: JSON.stringify({ user_id })
              });

              // Parse JSON once
              const data = await res.json();

              if (!res.ok) {
                let msg = data.message || 'Failed to launch';

                // ---- CLEAN DUPLICATE WORDS ---
                msg = msg.replace(/\b(\w+)\s+\1\b/gi, "$1");
                msg = msg.replace(/\bLaunch\s+Launch\b/gi, "Launch");
                this.$notyf.error(msg);
                return;
              }

              // Handle success paths
              if (data.status === 'success' && data.redirect_url) {
                localStorage.removeItem('sso_next');

                // Pass the token as a URL parameter
                const token = get_token();
                const separator = data.redirect_url.includes('?') ? '&' : '?';
                window.location = `${data.redirect_url}${separator}token=${token}`;
              } else {
                this.$notyf.error('Failed to launch platform');
              }

            } catch (error) {
              this.$notyf.error('Failed to launch');
            }
          } else {
            this.$router.push('/home');
          }
        } else {
          this.$notyf.error(data.error || data.message || "Invalid OTP");
        }
      } catch (err) {
        this.$notyf.error("A network error occurred. Please try again.");
      } finally {
        this.loading = false;
      }
    },

    async resend_otp() {
      this.resending = true;
      const csrf_url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_csrf_token/';
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/resend_otp/';
      try {
        await fetch(csrf_url, {
          method: 'GET',
          credentials: 'include'
        });
        this.csrfToken = getCookie('csrftoken');

        const res = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrfToken,
          },
        });
        const data = await res.json();
        if (data.status === 'success') {
          this.$notyf.success("OTP resent to your email");
        } else {
          this.$notyf.error(data.message || "Failed to resend OTP");
        }
      } catch (err) {
        this.$notyf.error("Network error while resending OTP");
      } finally {
        this.resending = false;
      }
    }
  }
}
